import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\DuplicateModel\MergeDuplicateModelsController::__invoke
* @see app/Http/Controllers/DuplicateModel/MergeDuplicateModelsController.php
* @route '/api/duplicate-update-models'
*/
const MergeDuplicateModelsController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: MergeDuplicateModelsController.url(options),
    method: 'post',
})

MergeDuplicateModelsController.definition = {
    methods: ["post"],
    url: '/api/duplicate-update-models',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\DuplicateModel\MergeDuplicateModelsController::__invoke
* @see app/Http/Controllers/DuplicateModel/MergeDuplicateModelsController.php
* @route '/api/duplicate-update-models'
*/
MergeDuplicateModelsController.url = (options?: RouteQueryOptions) => {
    return MergeDuplicateModelsController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\DuplicateModel\MergeDuplicateModelsController::__invoke
* @see app/Http/Controllers/DuplicateModel/MergeDuplicateModelsController.php
* @route '/api/duplicate-update-models'
*/
MergeDuplicateModelsController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: MergeDuplicateModelsController.url(options),
    method: 'post',
})

export default MergeDuplicateModelsController